<p-dialog
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [closable]="!saving"
  [dismissableMask]="!saving"
  [draggable]="false"
  [resizable]="false"
  header="Reasignar vendedor / broker"
  [style]="{ width: '540px' }"
  styleClass="reassign-owner-dialog">

  <div class="reassign-body" [formGroup]="form">
    <p class="reassign-hint">
      Cambia el <strong>vendedor interno</strong> (seguimiento) y/o el <strong>broker</strong> que trajo al cliente.
      Queda registrado en el Historial.
    </p>

    <!-- Estado actual (solo lectura) -->
    <div class="current-grid">
      <div class="current-item">
        <span class="lbl">Vendedor actual</span>
        <span class="val">{{ currentSellerName || '—' }}</span>
      </div>
      <div class="current-item">
        <span class="lbl">Broker actual</span>
        <span class="val">{{ currentBrokerName || 'Ninguno' }}</span>
      </div>
    </div>

    <!-- Vendedor interno -->
    <div class="field">
      <label for="sellerId"><i class="fa-solid fa-user-tie"></i> Vendedor interno (seguimiento)</label>
      <p-dropdown inputId="sellerId" formControlName="sellerId" [options]="sellers"
        optionLabel="label" optionValue="value" [filter]="true" filterBy="label"
        [showClear]="true" scrollHeight="220px" [autoDisplayFirst]="false"
        placeholder="Selecciona un vendedor" [style]="{ width: '100%' }">
      </p-dropdown>
    </div>

    <!-- Broker que trajo al cliente -->
    <div class="field">
      <label for="brokerId"><i class="fa-solid fa-user-group"></i> Broker que trajo al cliente</label>
      <p-dropdown inputId="brokerId" formControlName="brokerId" [options]="brokers"
        optionLabel="label" optionValue="value" [filter]="true" filterBy="label"
        [showClear]="true" scrollHeight="117px" [autoDisplayFirst]="false"
        placeholder="Sin broker" [style]="{ width: '100%' }">
      </p-dropdown>
      <small class="field-note">Atribución de quién lo trajo. No otorga seguimiento interno.</small>
    </div>

    <!-- Referido: inmutable -->
    <div class="immutable-box">
      <i class="pi pi-lock"></i>
      <span>Referido por: <strong>{{ referredByName || '—' }}</strong> · no editable</span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton pRipple type="button" label="Cancelar" icon="pi pi-times"
      class="p-button-outlined" (click)="close()" [disabled]="saving"></button>
    <button pButton pRipple type="button" label="Guardar cambios" icon="pi pi-check"
      (click)="save()" [disabled]="saving || !hasChanges" [loading]="saving"></button>
  </ng-template>
</p-dialog>

<p-toast position="top-right"></p-toast>
